import { render, staticRenderFns } from "./SymbolEditor.vue?vue&type=template&id=045f7e80&scoped=true&"
import script from "./SymbolEditor.vue?vue&type=script&lang=js&"
export * from "./SymbolEditor.vue?vue&type=script&lang=js&"
import style0 from "./SymbolEditor.vue?vue&type=style&index=0&id=045f7e80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f7e80",
  null
  
)

export default component.exports